import { format } from 'date-fns'
import baseApi from './baseApi'

const sortAndFormatData = (data) => {
  return data
    .sort((a, b) => {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)

      return dateB - dateA
    })
    .map((item) => {
      const formattedDate = format(new Date(item.date), 'dd-MM-yyyy hh:mm a')
      return {
        ...item,
        date: formattedDate,
      }
    })
}

export const eegReportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: () => `/get_all_category`,
      transformResponse: (data) => data.get_cat,
      providesTags: ['brain_report'],
    }),
    getProfileData: builder.query({
      query: ({ userId, isGroup, ...filters }) => ({
        url: '/profile_screen_aggregate',
        method: 'POST',
        body: { isGroup, user_id: userId, ...filters },
      }),
      transformResponse: (data) => {
        return {
          productivity: data.all.ProducitvityScale,
          charts: data.all.charts,
        }
      },
      providesTags: ['brain_report'],
    }),
    getCharacter: builder.query({
      query: ({ userId }) => `/roles_user?user_id=${userId}`,
      transformResponse: (data) => {
        return { title: data.character, desc: data.about.desc, image: data.about.image }
      },
      providesTags: ['brain_report'],
    }),
    getInsights: builder.query({
      query: ({ userId }) => ({
        url: `insights_json`,
        method: 'POST',
        body: { user_id: userId },
      }),
      providesTags: ['brain_report'],
    }),
    getRecommendedActivities: builder.mutation({
      query: ({ category, zone }) => ({
        method: 'GET',
        url: `get_activities?category=${category}&zone=${zone}`,
      }),
    }),
    getDocRecommendations: builder.query({
      query: ({ userId }) => ({
        url: `dr_recommend?user_id=${userId}`,
      }),
      transformResponse: (data) => {
        return sortAndFormatData(data)
      },
      providesTags: ['dr_recommended'],
    }),
    saveDocRecommendations: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: `dr_recommend`,
        body: data,
      }),
      invalidatesTags: ['dr_recommended'],
    }),
  }),
  overrideExisting: false,
})

// auto-generated based on the defined endpoints
export const {
  useGetCategoriesQuery,
  useGetProfileDataQuery,
  useGetCharacterQuery,
  useGetInsightsQuery,
  useGetRecommendedActivitiesMutation,
  useGetDocRecommendationsQuery,
  useSaveDocRecommendationsMutation,
} = eegReportApi
